import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class JudgementService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  getJudgements(page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(`${SETTINGS.CMS_API}/api/judgement?page=${page}&limit=${pageSize}`)
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve Courts');
            reject(error);
          },
        );
    });
  }

  getJudgementBySearch(
    name: string,
    page: number,
    pageSize: number,
  ): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/judgement?where[title][contains]=${name}&page=${page}&limit=${pageSize}`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve members');
            reject(error);
          },
        );
    });
  }

  getJudgementByDate(date: any, page: number, pageSize: number): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/judgement?where[date][equals]=${date}&page=${page}&limit=${pageSize}`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve members');
            reject(error);
          },
        );
    });
  }

  getJudgementByCourt(
    court: string,
    page: number,
    pageSize: number,
  ): Promise<any> {
    this.ngxLoader.start();
    return new Promise((resolve, reject) => {
      return this.http
        .get(
          `${SETTINGS.CMS_API}/api/judgement?where[court][equals]=${court}&page=${page}&limit=${pageSize}`,
        )
        .subscribe(
          (response) => {
            this.ngxLoader.stop();
            resolve(response);
          },
          (error) => {
            this.ngxLoader.stop();
            this.message.create('error', 'Failed to retrieve members');
            reject(error);
          },
        );
    });
  }

  private formatDate(data: any) {
    const originalDate = new Date(data);
    const oneDayInMillis = 24 * 60 * 60 * 1000;
    const newDateInMillis = originalDate.getTime() - oneDayInMillis;
    const newDate = new Date(newDateInMillis);
    return newDate.toISOString();
  }
}
